import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { Form } from "./components/Form";
import { StepperProvider } from "./Contexts/Stepper";
import { LanguageProvider } from "./Contexts/Language";
import { UserPhoneProvider } from "./Contexts/UserPhone";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <UserPhoneProvider>
        <StepperProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/delete-account" element={<Form />} />
                <Route path="/" element={<Navigate to="/delete-account" />} />
                <Route path="*" element={<Navigate to="/delete-account" />} />
              </Routes>
            </BrowserRouter>
          </div>
        </StepperProvider>
      </UserPhoneProvider>
    </LanguageProvider>
  );
}

export default App;
